export default {
  "home": "ACCUEIL",
  "news": "NOUVELLES",
  "community": "COMMUNAUTÉ",
  "character": "PERSONNAGES",
  "world": "CADRE DU MONDE",
  "features": "FEATURES",
  "topUp": "TOP UP",
  "customerService": "SERVICE CLIENT",
  "download": "TÉLÉCHARGER",
  "moreDownload": "Plus de méthodes de téléchargement",
  "screenshot": "CAPTURE D'ÉCRAN",
  "video": "CINÉMATIQUE",
  "poster": "POSTER",
  "downloadGame": "TÉLÉCHARGER",
  "scan": "Scanner le code QR pour télécharger",
  "prev": "Précédent",
  "next": "Suivant",
  "moreNews": "INFORMATIONS",
  "latest": "DERNIER",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "Encore aucun contenu",
  "goPay": "ALLER MAINTENANT",
  "payGuide": "EN SAVOIR PLUS",
  "stayTurn": "Restez à l’affût !",
  "huoyi": "Fourmi de Feu",
  "huoyi_text": "La Fourmi de Feu est l’une des espèces invasives les plus connues au monde, elle est aussi redoutée des autres fourmis.\r\nMalgré leur petite taille, environ 4 à 6 millimètres, elles sont incroyablement agressives et destructrices.",
  "huoyi_skill1": "Tactiques",
  "huoyi_skill2": "PV Soldate véloce",
  "huoyi_skill3": "DEF Soldate véloce",
  "huoyi_skill4": "ATT Soldate véloce ",
  "ciyi": "Fourmi Dard d'Or",
  "ciyi_text": "La fourmi Polyrhachis trapezoidea se retrouve généralement dans les forêts d'eucalyptus et les savanes d'Australie et son dos est couvert de rayures dorés ou orangées.\r\nSa carapace extérieure est très résistante et de petites épines se forment sur ses bords, ce qui constitue un bon moyen de défense contre les ennemis.",
  "ciyi_skill1": "Tactiques",
  "ciyi_skill2": "PV Tireuse",
  "ciyi_skill3": "DEF Tireuse",
  "ciyi_skill4": "ATT Tireuse ",
  "hongyi": "Fourmi Charognarde",
  "hongyi_text": "La fourmi Monomorium est une espèce mystérieuse ne disposant pas encore de nom précis. Le corps de ces fourmis fait environ 8mm de long et se caractérise par une marque rouge très reconnaissable sur le dos.",
  "hongyi_skill1": "Vitesse de Recherche",
  "hongyi_skill2": "Vitesse d'Entrainement",
  "hongyi_skill3": "Taille d'armée max",
  "jinjia": "Fourmi Moissonneuse",
  "jinjia_text": "Les fourmis Daceton armigerum, résidant dans les forêts tropicales d'Amazonie, sont des fourmis carnivores.\r\nLa taille de ces fourmis varie avec leur fonction, les soldates pouvant atteindre 15-17 mm.\r\nLeur nourriture est très diversifiée, se composant souvent d'une grande variété d'insectes ainsi que de petits escargots.\r\nElles peuvent non seulement mordre leur proie avec leurs puissantes mâchoires, mais aussi la piquer et lui injecter du venin pour mieux la vaincre.",
  "jinjia_skill1": "Tactiques",
  "jinjia_skill2": "PV Soldate de corps à corps",
  "jinjia_skill3": "DEF Soldate de corps à corps",
  "jinjia_skill4": "ATT Soldate de corps à corps ",
  "gongbei": "Fourmi Charpentière",
  "gongbei_text": "Les fourmis Camponotus mirabilis ne sont trouvables que dans les régions septentrionales d'Amérique du Sud, et sont aussi connues sous le nom de fantômes de l'Amazonie.\r\nElles élèvent généralement des pucerons dans les branches de bambou pour collecter le miellat qui leur sert de nourriture, mais elles chassent aussi quelques insectes à l'occasion.",
  "gongbei_skill1": "Vitesse d'Entrainement",
  "gongbei_skill2": "Rabais Nourriture requise pour Entrainement",
  "gongbei_skill3": "Rabais Coût d'Endurance",
  "specialAnt": "Fourmi spécialisée",
  "back": "Retour",
  "guide": "GUIDE",
  "announcement": "ANNONCEMENT",
  "event": 'ÉVÉNEMENT',
}
